// extracted by mini-css-extract-plugin
export default {"image":"Card_image__2k5eg"};